import { render, staticRenderFns } from "./TerminationlOrder.vue?vue&type=template&id=7807ce8b&scoped=true"
import script from "./TerminationlOrder.vue?vue&type=script&lang=js"
export * from "./TerminationlOrder.vue?vue&type=script&lang=js"
import style0 from "./TerminationlOrder.vue?vue&type=style&index=0&id=7807ce8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807ce8b",
  null
  
)

export default component.exports